import React from 'react'
import PropTypes from 'prop-types'

import './SavedAddressOption.css'

export const SavedAddressOption = ({
  name,
  deliveryInfo: {
    address1
  }
}) => (
  <span styleName='addressOption'>
    {name && <span styleName='addressName'>{name}</span>}
    <span> ({address1})</span>
  </span>
)

SavedAddressOption.propTypes = {
  name: PropTypes.string,
  deliveryInfo: PropTypes.shape({
    address1: PropTypes.string.isRequired
  }).isRequired
}
